/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { navigateTo } from '../../navigate-to/index.js';
import { env } from '../../env/index.js';
import '../../../tslib.es6-e01eabb2.js';
import '../../../index-e5fa4dec.js';
import '../../extend/index.js';
import '../../extend/register/index.js';
import '../../../index-f24a9ec1.js';
import '../../../bridges/dd/index.js';
import '../../../index-6f6b9acc.js';
import '../../../_commonjsHelpers-56d33373.js';
import '../../../loadscripts-cf212b8d.js';
import '../../../constants-163bd007.js';
import '../../../bridge-adpter-api-0316c034.js';
import '../../../bridges/windvane/index.js';
import '../../../bridges/nebula/index.js';
import '../../../index.es-142c5680.js';
import '../../../bridges/pangu-mini-app/index.js';
import '../../../log-aabf3a34.js';
import '../../../index-892d8eee.js';
import '../../navigate-to/cn/index.js';
import '../../../common-42e7d8d8.js';
import '../../../safe-data-66f20265.js';
import '../../navigate-to/cnStation/index.js';
import '../../navigate-to/tb/index.js';
import '../../navigate-to/ali1688/index.js';
import '../../navigate-to/fm/index.js';
import '../../navigate-to/nebula/index.js';
import '../../navigate-to/dingTalk/index.js';
import '../../navigate-to/dingTalkPC/index.js';
import '../../navigate-to/mini/index.js';
import '../../../index-ee2c9aee.js';
import '../../navigate-to/panguMiniApp/index.js';

var isTruthy = function (obj) { return obj !== undefined && obj !== null; };
var isFalsy = function (obj) { return !isTruthy(obj); };
var transformObjectToQueryString = function (target, encoded) {
    if (encoded === void 0) { encoded = true; }
    if (isFalsy(target)) {
        return '';
    }
    if (typeof target === 'string') {
        return target;
    }
    return Object.keys(target)
        .map(function (key) {
        if (isFalsy(target === null || target === void 0 ? void 0 : target[key])) {
            return '';
        }
        var value = encoded ? encodeURIComponent(target === null || target === void 0 ? void 0 : target[key]) : target === null || target === void 0 ? void 0 : target[key];
        return "".concat(key, "=").concat(value);
    })
        .filter(Boolean)
        .join('&');
};
var handleAmapApp = function (param) {
    var distance;
    try {
        var d = param.distance;
        if (typeof d === 'string') {
            d = d.replace('km', '');
        }
        d = Number(d);
        if (Number.isNaN(d)) {
            d = 10;
        }
        distance = d;
    }
    catch (e) {
        distance = 10;
    }
    var type = distance > 1 ? 0 : 2;
    var address = param.addressDetail || param.stationName || '';
    var longitude = param.longitude || '';
    var latitude = param.latitude || '';
    var url = transformObjectToQueryString({
        sid: 'BGVIS1',
        slat: '',
        slon: '',
        sname: '',
        did: 'BGVIS2',
        dlat: latitude,
        dlon: longitude,
        dname: address,
        dev: 0,
        t: type,
    });
    var navUrl = '';
    if (env.isIOS) {
        navUrl = "iosamap://path?sourceApplication=applicationName&".concat(url);
    }
    else {
        navUrl = "androidamap://route/plan/?".concat(url);
    }
    return navUrl;
};
function openAmapApp(options) {
    var navUrl = handleAmapApp(options);
    navigateTo({
        url: navUrl,
        success: options.success,
        fail: options.fail,
        complete: options.complete,
    });
}

export { openAmapApp as default, handleAmapApp };
